// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\na[data-v-26084dc2] {\n  text-decoration: none;\n}\na[data-v-26084dc2]:hover {\n  color: rgb(40, 91, 115);\n}\n", ""]);
// Exports
module.exports = exports;
